import React from 'react';
import { parseCloseSaleEnd } from './calendarEventHelpers';

/**
 * Point vert ou rouge selon `close_sale_date` uniquement (champ liste API).
 */
export default function SaleStatusBadge({ event }) {
    const closeEnd = parseCloseSaleEnd({
        close_sale_date: event?.close_sale_date ?? null,
    });
    if (!closeEnd || Number.isNaN(closeEnd.getTime())) return null;

    const ventesOuvertes = Date.now() < closeEnd.getTime();
    const labelFr = closeEnd.toLocaleString('fr-FR');

    const base =
        'inline-block h-2.5 w-2.5 shrink-0 rounded-full shadow-sm ring-2 motion-safe:transition-opacity';

    if (ventesOuvertes) {
        return (
            <span
                role="img"
                aria-label={`Ventes ouvertes jusqu’au ${labelFr}`}
                title={`Ventes ouvertes jusqu’au ${labelFr}`}
                className={`${base} animate-pulse bg-emerald-500 ring-emerald-400/50`}
            />
        );
    }

    return (
        <span
            role="img"
            aria-label={`Ventes closes depuis le ${labelFr}`}
            title={`Ventes closes depuis le ${labelFr}`}
            className={`${base} bg-red-600 ring-red-500/40`}
        />
    );
}
